import React from 'react';

export default function DeleteAccountPage() {
  return (
    <div className="font-satoshi max-w-5xl mx-auto p-8 space-y-8 text-gray-800 font-sans">
      <h1 className="text-4xl font-bold text-blue-900">Delete Your Account and Data</h1>

      <p className="text-lg leading-relaxed">
        At <span className="font-semibold">ClaimPro</span>, your privacy is our top priority. We are committed to protecting your personal information 
        and giving you full control over your data. We understand how important it is to feel safe and informed when using our services. However, please note that no method of internet transmission is 100% secure.
      </p>

      <section>
        <h2 className="text-2xl font-semibold text-blue-800 mb-4">How to Request Deletion:</h2>
        <ol className="list-decimal list-inside space-y-2 text-lg">
          <li>
            Please send an email to{' '}
            <a href="mailto:info@claimpro.in" className="text-blue-600 underline hover:text-blue-800">
              info@claimpro.in
            </a>{' '}
            with the subject <strong>"Account Deletion Request"</strong>.
          </li>
          <li>Include your registered email address or username associated with your account.</li>
          <li>We will review and process your request promptly, typically within <strong>30 days</strong>.</li>
        </ol>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-blue-800 mb-4">What Data Will Be Deleted:</h2>
        <ul className="list-disc list-inside space-y-2 text-lg">
          <li>Your personal information such as name, email address, phone number, etc.</li>
          <li>Uploaded documents and images related to your account.</li>
          <li>Your account activity, including service history and transaction records.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-blue-800 mb-4">Data Retention & Security:</h2>
        <p className="text-lg leading-relaxed mb-4">
          While we strive to delete all your personal data, some information may be retained to comply with legal obligations (for example, tax or financial records, etc.) or to prevent fraud and abuse. Any retained data will be securely stored and minimized to the extent possible.
        </p>
        <p className="text-lg leading-relaxed">
          Once your data is deleted, you will no longer be able to access your account or any associated services.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-blue-800 mb-4">We Care About Your Privacy</h2>
        <p className="text-lg leading-relaxed">
          Your trust matters to us. We are dedicated to maintaining transparency about how we collect, use, and protect your information. If you have any questions or concerns about your data or privacy, please read <span onClick={() => window.open('https://claimproassist-2.s3.ap-south-1.amazonaws.com/mainclaimpro/Terms+of+Use+Policy+v1.0.pdf', "_blank")} className='text-blue-400 cursor-pointer'>{" "}terms & conditions{" "} </span> and <span className='text-blue-400 cursor-pointer' onClick={() => window.open("https://onboard.claimpro.in/privacy-policy", "_blank")}>{" "}privacy policy{" "}</span>.
        </p>
        <p>
          Contact us anytime at{' '}
          <a href="mailto:info@claimpro.in" className="text-blue-600 underline hover:text-blue-800">
            info@claimpro.in
          </a>.
        </p>
      </section>
    </div>
  );
}
